// extracted by mini-css-extract-plugin
module.exports = {"documentChatButton":"l0jSSVid"};